var _defs, _g, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 224.57 224.26",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#1e1e1c;stroke-miterlimit:10;stroke-width:5px;}.cls-1{fill:url(#KUARA);}.cls-2{fill:url(#KUARA-2);}.cls-3{opacity:0.4;fill:url(#KUARA-3);}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KUARA",
    x1: 2.5,
    y1: 136.11,
    x2: 174.54,
    y2: 136.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e72677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662880"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KUARA-2",
    x1: 50.12,
    y1: 88.15,
    x2: 222.07,
    y2: 88.15,
    xlinkHref: "#KUARA"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KUARA-3",
    x1: 50.12,
    y1: 112.13,
    x2: 174.54,
    y2: 112.13,
    xlinkHref: "#KUARA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1 XoTkCqMB_0",
    d: "M174.4,84.72l-6.14,70.13-1.67,19L164.48,198l-1.34,15.25a9.44,9.44,0,0,1-2.68,5.71l0,0,0,0,0,.05a9.52,9.52,0,0,1-6.53,2.73H33.9C15,221.76,1,206.43,2.64,187.5l9-102.78C12.88,70.92,22.1,59,34.33,53.6a36,36,0,0,1,14.6-3.14h94.21C162.07,50.46,176.07,65.79,174.4,84.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2 XoTkCqMB_1",
    d: "M221.94,36.76l-3,34.26-3,34.26-5.22,59.95c0,.26-.06.52-.11.77a9.37,9.37,0,0,1-2.52,4.89h0l0,0-.13.14a9.57,9.57,0,0,1-6.51,2.75H81.52c-18.93,0-32.93-15.33-31.26-34.26l7.79-89.08,1.2-13.7C60.92,17.83,77.58,2.5,96.51,2.5h94.21C209.61,2.5,223.61,17.83,221.94,36.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3 XoTkCqMB_2",
    d: "M174.4,84.72l-7.81,89.08H81.52c-18.93,0-32.93-15.33-31.26-34.26l7.79-89.08h85.09C162.07,50.46,176.07,65.79,174.4,84.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4 XoTkCqMB_3",
    d: "M218.94,71l-3,34.26H160.23l-2.61,30a9.58,9.58,0,0,1-9.34,8.56h-8.56a15.46,15.46,0,0,1-15.64-17.13L126,105.28H96.42a7.74,7.74,0,0,1-7.84-7.58,6.63,6.63,0,0,1,0-1l.77-8.56A19,19,0,0,1,108,71H129l1.88-21.41a19.05,19.05,0,0,1,18.63-17.13,15.45,15.45,0,0,1,15.63,17.13L163.23,71Z"
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".XoTkCqMB_0{stroke-dasharray:621 623;stroke-dashoffset:622;animation:XoTkCqMB_draw_0 1400ms ease-out 0ms infinite,XoTkCqMB_fade 1400ms linear 0ms infinite;}.XoTkCqMB_1{stroke-dasharray:621 623;stroke-dashoffset:622;animation:XoTkCqMB_draw_1 1400ms ease-out 0ms infinite,XoTkCqMB_fade 1400ms linear 0ms infinite;}.XoTkCqMB_2{stroke-dasharray:454 456;stroke-dashoffset:455;animation:XoTkCqMB_draw_2 1400ms ease-out 0ms infinite,XoTkCqMB_fade 1400ms linear 0ms infinite;}.XoTkCqMB_3{stroke-dasharray:443 445;stroke-dashoffset:444;animation:XoTkCqMB_draw_3 1400ms ease-out 0ms infinite,XoTkCqMB_fade 1400ms linear 0ms infinite;}@keyframes XoTkCqMB_draw{100%{stroke-dashoffset:0;}}@keyframes XoTkCqMB_fade{0%{stroke-opacity:1;}92.85714285714286%{stroke-opacity:1;}100%{stroke-opacity:0;}}@keyframes XoTkCqMB_draw_0{28.57142857142857%{stroke-dashoffset: 622}66.66666666666666%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes XoTkCqMB_draw_1{34.920634920634924%{stroke-dashoffset: 622}73.01587301587301%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes XoTkCqMB_draw_2{41.26984126984127%{stroke-dashoffset: 455}79.36507936507937%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes XoTkCqMB_draw_3{47.61904761904762%{stroke-dashoffset: 444}85.71428571428571%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingLogo);
export default __webpack_public_path__ + "static/media/loadingLogo.4d834f7582355d3db24f2e958df0ae5f.svg";
export { ForwardRef as ReactComponent };